import { mixinActions, mixinMutations, mixinState, mixinGetters } from '../../mixins/vuexCRUD'

const getters = {
  ...mixinGetters(),
  hosTypes: (state) => state.items,
}

const state = {
  ...mixinState(),
  path: '/hosTypes',
}

const mutations = mixinMutations()

const actions = mixinActions()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
